export const featuredProducts = [
  {
    id: 1,
    name: "Meta Quest 3S 128GB — Fresco Theme — Pretty Pastel Vibes for a Fresh VR Experience",
    price: 299.99,
    image: "https://i5.walmartimages.com/seo/Meta-Quest-3S-128GB-Dive-into-Mixed-Reality-Unreal-device-Unreal-price-All-In-One-Headset-Get-a-3-Month-Trial-of-Meta-Horizon-Included_63a1cd26-8c14-49f5-a758-a49627a87802.60da3bc6e78f39aed803857d5ecb6811.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    category: "Gaming Consoles",
    rating: 4.5,
    inStock: true,
    specs: "128GB Storage, Fresco Theme, Snapdragon XR2 Gen 2, 4K+ Infinite Display, 3D Audio, Touch Plus Controllers"
  },
  {
    id: 14,
    name: "Meta Quest 3S 256GB — All-In-One Mixed Reality Headset",
    price: 399.99,
    image: "https://m.media-amazon.com/images/I/61nzPMNY8zL._AC_SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.6,
    inStock: true,
    specs: "256GB Storage, Snapdragon XR2 Gen 2, 4K+ Infinite Display, Full Color Passthrough, Touch Plus Controllers, Hand Tracking 2.0"
  },
  {
    id: 2,
    name: "Xbox Series X 2TB Disc Drive Galaxy Black Special Edition Bundle",
    price: 599.99,
    image: "https://m.media-amazon.com/images/I/51ojzJk77qL._AC_SX679_.jpg",
    category: "Gaming Consoles",
    rating: 4.2,
    inStock: true,
    specs: "2TB Storage, Galaxy Black Special Edition, 4K Gaming at 120fps, Ray Tracing, Quick Resume, Smart Delivery"
  },
  {
    id: 13,
    name: "Xbox Microsoft Series S 1TB SSD Console Carbon Black",
    price: 349.99,
    image: "https://m.media-amazon.com/images/I/61hwaBMvOxL._SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.6,
    inStock: true,
    specs: "1TB SSD Storage, Carbon Black, Wireless Controller Included, Up to 120 frames per second, 10GB RAM, 1440p Gaming"
  },
  {
    id: 10,
    name: "Halo Infinite — Xbox Series X, Xbox One",
    price: 59.99,
    image: "https://m.media-amazon.com/images/I/81nWynmiDPL._SL1500_.jpg",
    category: "Games",
    rating: 4.7,
    inStock: true,
    specs: "Xbox Series X|S Optimized, Xbox One Compatible, Campaign Mode, Free-to-Play Multiplayer, 4K Ultra HD, HDR Support"
  },
  {
    id: 15,
    name: "Lenovo IdeaCentre 3i Desktop Computer — Intel Core i5-12400, 32GB RAM, 1TB SSD",
    price: 549.99,
    image: "https://m.media-amazon.com/images/I/61qyljJp6BL._AC_SL1500_.jpg",
    category: "Desktop PCs",
    rating: 4.5,
    inStock: true,
    specs: "Intel Core i5-12400, 32GB DDR4 RAM, 1TB SSD, Intel UHD Graphics 730, Windows 11 Home, WiFi, Bluetooth, USB-C"
  },
  {
    id: 3,
    name: "DJI Osmo Pocket 3 Creator Combo",
    price: 649.99,
    image: "https://m.media-amazon.com/images/I/51d4Esi79-L._AC_SL1285_.jpg",
    category: "Accessories",
    rating: 4.6,
    inStock: true,
    specs: "1\" CMOS Sensor, 4K/120fps Video, 2\" Rotatable Touchscreen, 3-Axis Stabilization, ActiveTrack 6.0, Face/Object Tracking, Full-Pixel Fast Focusing"
  },
  {
    id: 4,
    name: "DJI Osmo Pocket 3",
    price: 519.00,
    image: "https://i5.walmartimages.com/seo/DJI-Osmo-Pocket-3-4K-Vlogging-Camera-1-CMOS-3-Axis-Stabilization-120fps-Wide-Lens_92449842-3d66-4c8e-8a52-9923f1d9b312.ba9c16d4c28f5203e84604031fc038e3.jpeg?odnHeight=573&odnWidth=573&odnBg=FFFFFF",
    category: "Accessories",
    rating: 4.6,
    inStock: true,
    specs: "1\" CMOS Sensor, 4K/120fps Video, 2\" Rotatable Touchscreen, 3-Axis Gimbal Stabilizer, Pocket-Sized Design, Face/Object Tracking"
  },
  {
    id: 6,
    name: "PlayStation 5 Slim Disc Edition Console",
    price: 549.99,
    image: "https://i5.walmartimages.com/seo/TEC-New-PlayStation-5-Disc-Slim-Edition-4K-Gaming-Console-Ultra-Fast-SSD_824149f9-a1e5-4a47-95d7-8cda17969930.fc95a749ffcec8d7afa4e66cf349f950.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    category: "Gaming Consoles",
    rating: 4.8,
    inStock: true,
    specs: "1TB SSD Storage, 4K Gaming, 120fps, Ray Tracing, DualSense Controller, Ultra HD Blu-ray"
  },
  {
    id: 9,
    name: "PlayStation Classic Console",
    price: 99.99,
    image: "https://m.media-amazon.com/images/I/61SUPJStPoL._AC_SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.3,
    inStock: true,
    specs: "20 Pre-loaded Games, HDMI Output, 2 Controllers Included, Plug and Play, Classic PlayStation Design, 720p/480p Output"
  },
  {
    id: 11,
    name: "HP Stream 14\" HD Laptop — Intel Celeron N4120, 4GB RAM, 64GB eMMC, Pink",
    price: 169.99,
    image: "https://m.media-amazon.com/images/I/61crnNsCGIL._AC_SL1500_.jpg",
    category: "Laptops",
    rating: 4.2,
    inStock: true,
    specs: "14\" HD Display, Intel Celeron N4120, 4GB RAM, 64GB eMMC, Windows 11 Home S Mode, 1 Year Microsoft 365, Thin & Portable"
  },
  {
    id: 12,
    name: "HP Stream 14\" Laptop — Intel Celeron N4120, 64GB eMMC, Blue",
    price: 189.99,
    image: "https://m.media-amazon.com/images/I/71oBgmSqHzL._AC_SL1500_.jpg",
    category: "Laptops",
    rating: 4.3,
    inStock: true,
    specs: "14\" HD Display, Intel Celeron N4120, 4GB RAM, 64GB eMMC, Windows 11 Home S Mode, Office 365 Personal 1 Year, Portable Design"
  }
];

export const allProducts = [
  {
    id: 1,
    name: "Meta Quest 3S 128GB — Fresco Theme — Pretty Pastel Vibes for a Fresh VR Experience",
    price: 299.99,
    image: "https://i5.walmartimages.com/seo/Meta-Quest-3S-128GB-Dive-into-Mixed-Reality-Unreal-device-Unreal-price-All-In-One-Headset-Get-a-3-Month-Trial-of-Meta-Horizon-Included_63a1cd26-8c14-49f5-a758-a49627a87802.60da3bc6e78f39aed803857d5ecb6811.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    category: "Gaming Consoles",
    rating: 4.5,
    inStock: true,
    specs: "128GB Storage, Fresco Theme, Snapdragon XR2 Gen 2, 4K+ Infinite Display, 3D Audio, Touch Plus Controllers, Mixed Reality, Hand Tracking 2.0",
    description: `The Meta Quest 3S 128GB in Fresco Theme brings pretty pastel vibes for a fresh VR experience. This standalone VR headset delivers incredible immersive experiences without the need for a PC or console.

Powered by the Snapdragon XR2 Gen 2 processor, enjoy smooth gameplay and stunning visuals with the 4K+ Infinite Display. The mixed reality capabilities let you blend your physical space with virtual worlds for truly unique experiences.

With 128GB of storage, you'll have plenty of room for your favorite games, apps, and experiences. The Touch Plus controllers provide precise tracking and intuitive controls for all your VR adventures.`,
    features: [
      "Snapdragon XR2 Gen 2 Processor",
      "128GB Internal Storage",
      "4K+ Infinite Display (1832 x 1920 per eye)",
      "Pancake Lenses for clearer visuals",
      "Full Color Mixed Reality Passthrough",
      "Hand Tracking 2.0",
      "Touch Plus Controllers included",
      "3D Spatial Audio",
      "Wi-Fi 6E Support",
      "Up to 2.5 hours battery life",
      "Adjustable IPD (58-71mm)",
      "Access to thousands of VR games and apps",
      "Meta Horizon OS",
      "Fresco Theme exclusive design"
    ],
    images: [
      "https://i5.walmartimages.com/seo/Meta-Quest-3S-128GB-Dive-into-Mixed-Reality-Unreal-device-Unreal-price-All-In-One-Headset-Get-a-3-Month-Trial-of-Meta-Horizon-Included_63a1cd26-8c14-49f5-a758-a49627a87802.60da3bc6e78f39aed803857d5ecb6811.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
      "https://i5.walmartimages.com/asr/c18af239-8c49-4152-9776-91608e76331c.41e6a3485212c8f22fdc7f298ada43df.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
      "https://i5.walmartimages.com/asr/a4b90eab-4569-4907-af3e-43a2b10bf9b1.2f4d93db862eb94e3a9a9e8fec10c955.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF"
    ]
  },
  {
    id: 14,
    name: "Meta Quest 3S 256GB — All-In-One Mixed Reality Headset",
    price: 399.99,
    image: "https://m.media-amazon.com/images/I/61-SGpdmgRL._SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.6,
    inStock: true,
    specs: "256GB Storage, Snapdragon XR2 Gen 2, 4K+ Infinite Display, Full Color Passthrough, Touch Plus Controllers, Hand Tracking 2.0, 3D Spatial Audio",
    description: `The Meta Quest 3S 256GB is the ultimate all-in-one mixed reality headset with double the storage. Dive into an extraordinary lineup of over 1,000+ immersive apps, games, and experiences with no PC or console required.

Powered by the Snapdragon XR2 Gen 2 processor, experience smooth performance and stunning visuals. The full-color passthrough lets you seamlessly blend your physical surroundings with the virtual world for incredible mixed reality experiences.

With 256GB of storage, you'll have plenty of space for your entire VR library. The included Touch Plus controllers deliver precise tracking, while Hand Tracking 2.0 lets you interact naturally without controllers. Get a 3-month trial of Meta Quest+ included with your purchase.`,
    features: [
      "Snapdragon XR2 Gen 2 Processor",
      "256GB Internal Storage — Double the space",
      "4K+ Infinite Display (1832 x 1920 per eye)",
      "Pancake Lenses for clearer visuals",
      "Full Color Mixed Reality Passthrough",
      "Hand Tracking 2.0",
      "Touch Plus Controllers included",
      "3D Spatial Audio",
      "Wi-Fi 6E Support",
      "Up to 2.5 hours battery life",
      "Adjustable IPD (58-71mm)",
      "Access to 1,000+ VR games and apps",
      "Meta Horizon OS",
      "3-Month Meta Quest+ Trial included",
      "Backward compatible with Quest 2 games"
    ],
    images: [
      "https://m.media-amazon.com/images/I/61-SGpdmgRL._SL1500_.jpg",
      "https://m.media-amazon.com/images/I/71AJhtYs8WL._SL1500_.jpg",
      "https://m.media-amazon.com/images/I/71FGofZzEJL._SL1500_.jpg",
      "https://m.media-amazon.com/images/I/71DNR-FaGoL._SL1500_.jpg"
    ]
  },
  {
    id: 2,
    name: "Xbox Series X 2TB Disc Drive Galaxy Black Special Edition Bundle",
    price: 599.99,
    image: "https://m.media-amazon.com/images/I/51ojzJk77qL._AC_SX679_.jpg",
    category: "Gaming Consoles",
    rating: 4.2,
    inStock: true,
    specs: "2TB Storage, Galaxy Black Special Edition, 4K Gaming at 120fps, Ray Tracing, Quick Resume, Smart Delivery, Special Edition Wireless Controller"
  },
  {
    id: 13,
    name: "Xbox Microsoft Series S 1TB SSD Console Carbon Black",
    price: 349.99,
    image: "https://m.media-amazon.com/images/I/61hwaBMvOxL._SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.6,
    inStock: true,
    specs: "1TB SSD Storage, Carbon Black, Wireless Controller Included, Up to 120 frames per second, 10GB RAM, 1440p Gaming"
  },
  {
    id: 10,
    name: "Halo Infinite — Xbox Series X, Xbox One",
    price: 59.99,
    image: "https://m.media-amazon.com/images/I/81nWynmiDPL._SL1500_.jpg",
    category: "Games",
    rating: 4.7,
    inStock: true,
    specs: "Xbox Series X|S Optimized, Xbox One Compatible, Campaign Mode, Free-to-Play Multiplayer, 4K Ultra HD, HDR Support, Smart Delivery"
  },
  {
    id: 15,
    name: "Lenovo IdeaCentre 3i Desktop Computer — Intel Core i5-12400, 32GB RAM, 1TB SSD",
    price: 549.99,
    image: "https://m.media-amazon.com/images/I/61qyljJp6BL._AC_SL1500_.jpg",
    category: "Desktop PCs",
    rating: 4.5,
    inStock: true,
    specs: "Intel Core i5-12400, 32GB DDR4 RAM, 1TB SSD, Intel UHD Graphics 730, Windows 11 Home, WiFi, Bluetooth, USB-C"
  },
  {
    id: 3,
    name: "DJI Osmo Pocket 3 Creator Combo",
    price: 649.99,
    image: "https://m.media-amazon.com/images/I/51d4Esi79-L._AC_SL1285_.jpg",
    category: "Accessories",
    rating: 4.6,
    inStock: true,
    specs: "1\" CMOS Sensor, 4K/120fps Video, 2\" Rotatable Touchscreen, 3-Axis Stabilization, ActiveTrack 6.0, Face/Object Tracking, Full-Pixel Fast Focusing"
  },
  {
    id: 4,
    name: "DJI Osmo Pocket 3",
    price: 519.00,
    image: "https://i5.walmartimages.com/seo/DJI-Osmo-Pocket-3-4K-Vlogging-Camera-1-CMOS-3-Axis-Stabilization-120fps-Wide-Lens_92449842-3d66-4c8e-8a52-9923f1d9b312.ba9c16d4c28f5203e84604031fc038e3.jpeg?odnHeight=573&odnWidth=573&odnBg=FFFFFF",
    category: "Accessories",
    rating: 4.6,
    inStock: true,
    specs: "1\" CMOS Sensor, 4K/120fps Video, 2\" Rotatable Touchscreen, 3-Axis Gimbal Stabilizer, Pocket-Sized Design, Face/Object Tracking"
  },
  {
    id: 6,
    name: "PlayStation 5 Slim Disc Edition Console",
    price: 549.99,
    image: "https://i5.walmartimages.com/seo/TEC-New-PlayStation-5-Disc-Slim-Edition-4K-Gaming-Console-Ultra-Fast-SSD_824149f9-a1e5-4a47-95d7-8cda17969930.fc95a749ffcec8d7afa4e66cf349f950.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
    category: "Gaming Consoles",
    rating: 4.8,
    inStock: true,
    specs: "1TB SSD Storage, 4K Gaming, 120fps, Ray Tracing, DualSense Controller, Ultra HD Blu-ray"
  },
  {
    id: 9,
    name: "PlayStation Classic Console",
    price: 99.99,
    image: "https://m.media-amazon.com/images/I/61SUPJStPoL._AC_SL1500_.jpg",
    category: "Gaming Consoles",
    rating: 4.3,
    inStock: true,
    specs: "20 Pre-loaded Games, HDMI Output, 2 Controllers Included, Plug and Play, Classic PlayStation Design, 720p/480p Output"
  },
  {
    id: 11,
    name: "HP Stream 14\" HD Laptop — Intel Celeron N4120, 4GB RAM, 64GB eMMC, Pink",
    price: 169.99,
    image: "https://m.media-amazon.com/images/I/61crnNsCGIL._AC_SL1500_.jpg",
    category: "Laptops",
    rating: 4.2,
    inStock: true,
    specs: "14\" HD Display, Intel Celeron N4120, 4GB RAM, 64GB eMMC, Windows 11 Home S Mode, 1 Year Microsoft 365, Thin & Portable"
  },
  {
    id: 12,
    name: "HP Stream 14\" Laptop — Intel Celeron N4120, 64GB eMMC, Blue",
    price: 189.99,
    image: "https://m.media-amazon.com/images/I/71oBgmSqHzL._AC_SL1500_.jpg",
    category: "Laptops",
    rating: 4.3,
    inStock: true,
    specs: "14\" HD Display, Intel Celeron N4120, 4GB RAM, 64GB eMMC, Windows 11 Home S Mode, Office 365 Personal 1 Year, Portable Design"
  }
];

const categoryData = [
  {
    id: 1,
    name: "Gaming Consoles",
    image: "https://cdn.mos.cms.futurecdn.net/CrtPtZAGFRgNrbFP7waPc9-650-80.jpg.webp",
    color: "#FF6B6B"
  },
  {
    id: 2,
    name: "Laptops",
    image: "https://igotoffer.com/microsoft/wp-content/uploads/sites/2/2016/10/types-laptops-all.jpg",
    color: "#4ECDC4"
  },
  {
    id: 3,
    name: "Desktop PCs",
    image: "https://public.readdy.ai/ai/img_res/dd7925d64e91c018250876fa8e48780a.jpg",
    color: "#95A5A6"
  },
  {
    id: 4,
    name: "Accessories",
    image: "https://readdy.ai/api/search-image?query=Modern%20tech%20accessories%20display%20featuring%20wireless%20headphones%20action%20camera%20and%20smartphone%20gimbal%20arranged%20artistically%20on%20gradient%20background%20with%20warm%20peach%20and%20amber%20tones%20clean%20minimalist%20product%20photography%20studio%20lighting&width=600&height=600&seq=cat004new&orientation=squarish",
    color: "#F4A261"
  },
  {
    id: 5,
    name: "Home and Kitchen",
    image: "https://readdy.ai/api/search-image?query=Modern%20kitchen%20appliances%20collection%20featuring%20stainless%20steel%20coffee%20maker%20air%20fryer%20and%20blender%20arranged%20on%20white%20marble%20countertop%20with%20soft%20natural%20lighting%20clean%20minimalist%20aesthetic%20warm%20cozy%20home%20atmosphere%20professional%20product%20photography&width=600&height=600&seq=cat005homekitchen&orientation=squarish",
    color: "#E07A5F"
  }
];

// Additional Gaming Console image options for selection
export const gamingConsoleImageOptions = [
  {
    option: 1,
    description: "Clean studio setup - White PS5 on pedestal with purple/blue lighting",
    url: "https://readdy.ai/api/search-image?query=White%20PlayStation%205%20console%20with%20black%20accents%20standing%20vertically%20on%20modern%20white%20pedestal%20with%20DualSense%20controller%20in%20front%20soft%20gradient%20background%20with%20purple%20and%20blue%20ambient%20lighting%20professional%20product%20photography%20studio%20setup%20clean%20minimalist%20composition&width=600&height=600&seq=cat001option1&orientation=squarish"
  },
  {
    option: 2,
    description: "Floating consoles - PS5, Xbox Series X, Nintendo Switch floating in space",
    url: "https://readdy.ai/api/search-image?query=White%20PlayStation%205%20console%20Xbox%20Series%20X%20black%20console%20and%20Nintendo%20Switch%20OLED%20floating%20together%20in%20futuristic%20tech%20space%20with%20holographic%20elements%20and%20cyan%20magenta%20gradient%20lighting%20modern%20product%20photography%20dynamic%20composition%20with%20depth&width=600&height=600&seq=cat001option2&orientation=squarish"
  },
  {
    option: 3,
    description: "Gaming setup scene - PS5 in modern entertainment center with LED strips",
    url: "https://readdy.ai/api/search-image?query=White%20PlayStation%205%20console%20with%20black%20accents%20in%20modern%20entertainment%20center%20setup%20with%20ambient%20LED%20strip%20lighting%20DualSense%20controller%20on%20surface%20warm%20orange%20and%20teal%20color%20scheme%20cozy%20gaming%20atmosphere%20professional%20interior%20photography%20shallow%20depth%20of%20field&width=600&height=600&seq=cat001option3&orientation=squarish"
  },
  {
    option: 4,
    description: "Hero shot - PS5 with dramatic spotlight and controller accessories",
    url: "https://readdy.ai/api/search-image?query=White%20PlayStation%205%20console%20standing%20vertically%20with%20dramatic%20spotlight%20from%20above%20DualSense%20wireless%20controller%20and%20charging%20station%20accessories%20arranged%20around%20base%20dark%20gradient%20background%20with%20rim%20lighting%20cinematic%20product%20photography%20high%20contrast%20professional%20studio%20shot&width=600&height=600&seq=cat001option4&orientation=squarish"
  },
  {
    option: 5,
    description: "Minimalist flat lay - PS5 console and accessories from top view",
    url: "https://readdy.ai/api/search-image?query=White%20PlayStation%205%20console%20laid%20flat%20with%20DualSense%20controller%20headset%20and%20games%20arranged%20symmetrically%20top%20down%20view%20minimalist%20flat%20lay%20photography%20soft%20pastel%20gradient%20background%20with%20pink%20and%20mint%20green%20tones%20clean%20modern%20aesthetic%20professional%20product%20photography&width=600&height=600&seq=cat001option5&orientation=squarish"
  }
];

export const categories = categoryData.map(category => ({
  ...category,
  count: allProducts.filter(product => product.category === category.name).length
}));
